import { h } from "preact";
import './badge.scss'
import {t} from "../../../_i18n";

interface Props {
    className?: string,
}

export default function TrialBadge ({className = ''}: Props){

    return (
        <span className={`${className} trial-badge translucent`}>{t('Sólo para alumnos')}</span>
    )
}
